import React from 'react';
import { Mic, CameraVideo, Display } from 'react-bootstrap-icons';
import LivePreview from './LivePreview';

const MODES = [
  {
    Icon: Mic,
    title: 'Talk it through',
    body: 'Ask out loud and hear the answer back. Interrupt any time — it stops and listens, just like a real tutor.',
    tint: 'bg-brand-mint/20 text-brand-mint',
  },
  {
    Icon: CameraVideo,
    title: 'Show your work',
    body: 'Point your camera at a worksheet or a science experiment and ask about what it sees.',
    tint: 'bg-brand-coral/20 text-brand-coral',
  },
  {
    Icon: Display,
    title: 'Share your screen',
    body: 'Stuck in an app or on a question? Share your screen and get walked through it live.',
    tint: 'bg-brand-violet/20 text-brand-violet',
  },
];

export default function LiveMode({ onSignIn }) {
  return (
    <section id="live" className="scroll-mt-24 bg-brand-navy-50 py-14 sm:py-16">
      <div className="mx-auto grid max-w-landing items-center gap-10 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
        <div>
          <div className="flex items-center gap-2">
            <span className="rounded-pill bg-brand-navy px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-white">
              New
            </span>
            <p className="m-0 text-sm font-semibold uppercase tracking-wide text-brand-navy">
              Live mode
            </p>
          </div>

          <h2 className="mt-2 font-display text-3xl font-extrabold text-brand-ink sm:text-4xl">
            Or just talk to it
          </h2>
          <p className="mt-3 max-w-xl text-brand-muted">
            Tap the microphone and have a real conversation — no typing. Turn on your
            camera or share your screen and SchoolCracked can see what you are working
            on while you talk it through.
          </p>

          <div className="mt-8 space-y-4">
            {MODES.map(({ Icon, title, body, tint }) => (
              <div key={title} className="flex gap-3.5">
                <span
                  className={`inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${tint}`}
                >
                  <Icon size={18} />
                </span>
                <div>
                  <h3 className="font-display text-base font-bold text-brand-ink">
                    {title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-brand-muted">{body}</p>
                </div>
              </div>
            ))}
          </div>

          <button
            type="button"
            onClick={onSignIn}
            className="mt-8 rounded-pill bg-brand-navy px-6 py-3 text-base font-semibold text-white shadow-brand-md transition hover:bg-brand-navy-800"
          >
            Try live mode
          </button>
          <p className="mt-3 text-sm text-brand-muted">
            Every live session is saved as a written transcript in your history.
          </p>
        </div>

        <LivePreview />
      </div>
    </section>
  );
}
